import { InvoiceHistoryItem } from '../models/InvoiceHistoryItem'
import { ReceiverBusiness } from '../models/ReceiverBusiness'
import { HttpRequest } from "../utils"

export type Dashboard = {
  amounts: {
    name: string
    amount: number
    change: number
  }[]
  confirmedAmounts: {
    date: string
    confirmedAmount: number
    paidAmount: number
  }[]
  pendingStats: {
    date: string
    pendingCount: number
    pendingAmount: number
  }[]
  overdueStats: {
    name: string
    invoiceCount: number
    amountToPay: number
    businessCount: number
    averageAmount: number
  }[]
  highestRemainder: (ReceiverBusiness & {
    invoiceCount: number
    amountToPay: number
    overdueAmount: number
  })[]
  byClassification?: {
    name: string
    count: number
    change: number
    priorities?: {
      name: string
      count: number
      change: number
    }[]
  }
  recentlyPaid: InvoiceHistoryItem[]
}

const httpRequest = new HttpRequest()

export const invoice = async (data: any) => httpRequest.get("/inv/dashboard/invoice", data)

export const main = async (data: any) => httpRequest.get<Dashboard>("/inv/dashboard/main", data)

export const recentInvoices = async () => httpRequest.get<any[]>("/inv/dashboard/recent-invoices")
